import { Card } from "./ui/card";
import { Shield, FileCheck, ShieldCheck, QrCode, Lock, MapPin } from "lucide-react";
import { motion } from "framer-motion";

const features = [
  {
    icon: Shield,
    title: "Independent & transparent",
    description: "Patient-led reviews of prescribed products. No ads, no pricing, no medical advice.",
  },
  {
    icon: FileCheck,
    title: "Batch-aware catalogue",
    description: "Every review is tied to a real product + batch; with certificates shown where available.",
  },
  {
    icon: ShieldCheck,
    title: "Moderated for safety",
    description: "We block dosage/curative claims and remove personal data from images. Human review backs the filters.",
  },
  {
    icon: QrCode,
    title: "Verified patients only",
    description: "Clinics issue short-lived QR tokens. We only see green or red so we hold no medical records.",
  },
  {
    icon: Lock,
    title: "Privacy-first & GDPR",
    description: "Explicit consent (GDPR Art. 6 & 9), data export/delete, encryption in transit and at rest, UK/EU hosting.",
  },
  {
    icon: MapPin,
    title: "Clinic directory",
    description: "Browse licensed UK clinics. Independent listings; no referral fees.",
  },
];

export function Features() {
  return (
    <section id="features" className="py-24 px-4 sm:px-6 lg:px-8 bg-muted/30">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <motion.div 
          className="text-center max-w-3xl mx-auto mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-4xl sm:text-5xl mb-6">
            Built for transparency,
            <span className="block text-primary">not promotion</span>
          </h2>
          <p className="text-xl text-muted-foreground">
            We compliment your medical journey
          </p>
        </motion.div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <Card key={index} className="p-8 hover:shadow-lg transition-all duration-300 hover:border-primary/30 bg-card h-full">
              <div className="w-12 h-12 rounded-xl gradient-green flex items-center justify-center mb-6">
                <feature.icon className="w-6 h-6 text-white" />
              </div>
              <h3 className="text-xl mb-3">{feature.title}</h3>
              <p className="text-muted-foreground leading-relaxed">{feature.description}</p>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
